import { useTranslation } from 'react-i18next'
import { exportExcel } from 'Utils/Utils'
import { useGetDynamicDataQuery } from 'redux/store/actions'
import { useState, useEffect } from 'react'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { Table } from 'components/TableComponents/Table'
import { useSelector } from 'react-redux'

interface Props {
  endPoint?: string
  headers?: any
}
export function TableActions(props: Props): JSX.Element {
  const { t } = useTranslation()
  const [endPoint, setEndPoint] = useState<string | null>(null)
  const [action, setAction] = useState<string | null>(null)
  const { data } = useGetDynamicDataQuery(
    action ? { endPoint, params: { allPages: true } } : skipToken
  )

  useEffect(() => {
    if (data?.data) {
      if (action === 'Excel') exportExcel(data?.data, props.headers, endPoint)
      if (action === 'Print') {
        window.print()
        setTimeout(() => {
          setAction(null)
        }, 2000)
      }
    }
  }, [data])
  const handleAction = (actionName: string): void => {
    if (props.endPoint) {
      setEndPoint(props.endPoint)
      setAction(actionName)
    }
    if (data?.data) {
      if (actionName === 'Excel') exportExcel(data?.data, props.headers, endPoint)
      if (actionName === 'Print') {
        setTimeout(() => {
          window.print()
        }, 500)
        setTimeout(() => {
          setAction(null)
        }, 2000)
      }
    }
  }
  return (
    <div className="flex justify-end py-3 ">
      {/* <button className="btn-white-outline w-24 me-2" type="button" onClick={() => handleAction('Excel')}>
        {t('Export')}
      </button>
      <button className="btn-white-outline w-24 " type="button" onClick={() => handleAction('Print')}>
        {t('Print')}
      </button> */}

      {action === 'Print' && (
        <div className="absolute top-0 right-0 left-0 h-full w-full z-50  bg-white hidden print:block">
          <Table
            tableHeaders={[
              ...props.headers.map((x: any) => {
                return x.value !== 'Actions' && { ...x }
              }),
            ]}
            elements={data?.data || []}
          />
        </div>
      )}
    </div>
  )
}
